"use client";

import { useEffect, useRef, useState } from "react";

/** نمایش پیام کوتاه (مثل toast در forum.html). از هر جا با toast() در lib/forum.client فراخوانی می‌شود. */
export default function ForumToaster() {
    const [msg, setMsg] = useState("");
    const [show, setShow] = useState(false);
    const timer = useRef<ReturnType<typeof setTimeout> | null>(null);

    useEffect(() => {
        const handler = (e: Event) => {
            setMsg(String((e as CustomEvent).detail ?? ""));
            setShow(true);
            if (timer.current) clearTimeout(timer.current);
            timer.current = setTimeout(() => setShow(false), 2600);
        };
        window.addEventListener("forum:toast", handler);
        return () => {
            window.removeEventListener("forum:toast", handler);
            if (timer.current) clearTimeout(timer.current);
        };
    }, []);

    return (
        <div
            className={`pointer-events-none fixed bottom-[22px] left-1/2 z-[100] -translate-x-1/2 rounded-full bg-gray-900 px-[22px] py-2.5 text-sm text-white transition-all duration-200 motion-reduce:transition-none ${
                show ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"
            }`}
            role="status"
            aria-live="polite"
        >
            {msg}
        </div>
    );
}
